import credentials from '@/credentials';

// initialed state
export const initialState = () => ({
	isLoggedIn: !!credentials.token,
	user: null,
	loading: false,
	isUserRegistrationLoading: false,
	account: null,
	pubSubToken: null,
	pubSubRefreshToken: null,
	isLoadingUserData: false,
});

const state = initialState();

export default state;
